<template>
  <div class="estate">
    <header-top></header-top>
    <div class="header-title">楼盘列表</div>
    <div class="estate-main">
      <div class="main-top">
        <el-input
          :placeholder="searchText"
          v-model="searchValue"
          class="input-with-select"
          clearable
        >
          <el-select
            v-model="search"
            slot="prepend"
            placeholder="楼盘名称"
            @change="filterSelect"
          >
            <el-option
              v-for="item in searchOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="searchEstates"
          ></el-button>
        </el-input>
      </div>
      <div class="main-filter">
        <div class="filter-item">
          <span class="filter-lable">地理位置:</span>
          <span
            class="filter-lable"
            :class="{ 'is-selected': item.data.isSelected }"
            v-for="(item, index) in filterData.position"
            @click="
              selectItem(
                filterData.position,
                item.data.name,
                item.data.name,
                '位置',
                'position'
              )
            "
            :key="index"
            >{{ item.data.name }}</span
          >
        </div>
        <div
          class="filter-item filter-children-item"
          v-if="filterData.district.length > 0"
        >
          <!-- <span class="filter-lable"></span> -->
          <span
            class="filter-lable"
            :class="{ 'is-selected': item.data.isSelected }"
            v-for="(item, index) in filterData.district"
            @click="
              selectItem(
                filterData.district,
                item.data.name,
                item.data.name,
                '区县',
                'district'
              )
            "
            :key="index"
            >{{ item.data.name }}</span
          >
        </div>
        <div class="filter-item">
          <span class="filter-lable">销售状态:</span>
          <span
            class="filter-lable"
            :class="{ 'is-selected': item.isSelected }"
            v-for="(item, index) in filterData.saleStatus"
            :key="index"
            @click="
              selectItem(
                filterData.saleStatus,
                item.label,
                item.value,
                '销售状态',
                'saleStatus'
              )
            "
            >{{ item.label }}</span
          >
        </div>
        <div class="filter-item">
          <span class="filter-lable">网站上架:</span>
          <span
            class="filter-lable"
            :class="{ 'is-selected': item.isSelected }"
            v-for="(item, index) in filterData.isPutWeb"
            :key="index"
            @click="
              selectItem(
                filterData.isPutWeb,
                item.label,
                item.value,
                '网站上架',
                'isPutWeb'
              )
            "
            >{{ item.label }}</span
          >
        </div>
        <div class="filter-item">
          <span class="filter-lable">渠道上架:</span>
          <span
            class="filter-lable"
            :class="{ 'is-selected': item.isSelected }"
            v-for="(item, index) in filterData.isPutChannel"
            :key="index"
            @click="
              selectItem(
                filterData.isPutChannel,
                item.label,
                item.value,
                '渠道上架',
                'isPutChannel'
              )
            "
            >{{ item.label }}</span
          >
        </div>
        <div class="filter-item filter-filter">
          <span class="filter-lable">筛选条件:</span>
          <div>
            <el-dropdown
              @command="dropdownClick"
              placement="bottom-start"
              :ref="item.name"
              v-for="(item, index) in filterData.filter"
              :key="index"
            >
              <span class="el-dropdown-link">
                {{ item.name }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" class="filter-dropdown">
                <el-dropdown-item
                  :command="
                    item.name +
                    ' ' +
                    el.name +
                    ' ' +
                    el.value +
                    ' ' +
                    item.label
                  "
                  v-for="(el, i) in item.children"
                  :key="i"
                  :class="{ 'dropdown-hover': el.hasOwnProperty('children') }"
                >
                  <div
                    class="dropdown-item"
                    v-if="el.hasOwnProperty('children')"
                  >
                    {{ el.name }}
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </div>
                  <el-date-picker
                    v-else-if="el.name == '自定义'"
                    v-model="filterDate"
                    @change="changeFilterDate(filterDate, item.name)"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :default-time="['00:00:00', '23:59:59']"
                  ></el-date-picker>
                  <div
                    class="dropdown-items"
                    v-if="el.hasOwnProperty('children')"
                  >
                    <div
                      v-for="ele in el.children"
                      :key="ele"
                      class="dropdown-item"
                      @click.stop="dropdownChildClick(item.name + ' ' + ele)"
                    >
                      {{ ele }}
                    </div>
                  </div>
                  <span v-else>{{ el.name }}</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
      <div class="main-condition" v-if="filterTags.length">
        <div class="condition-text">当前找房条件</div>
        <div class="tag-items">
          <el-tag
            v-for="tag in filterTags"
            :key="tag.name"
            size="medium"
            :disable-transitions="false"
            @close="handleTagClose(tag)"
            closable
            >{{ tag.name }}：{{ tag.label }}</el-tag
          >
          <div class="clear-btn" @click="clearTags">
            <i class="el-icon-delete"></i>清空条件
          </div>
        </div>
      </div>
      <div class="main-btns">
        <div>
          <el-button type="primary" icon="el-icon-plus" @click="createEstate"
            >添加楼盘</el-button
          >
          <el-button
            icon="el-icon-close"
            :disabled="multipleSelection.length == 0"
            @click="delEstates"
            >批量删除</el-button
          >
          <span class="table-top">
            共 {{ estates.length }} 条，已选
            <span class="selected-num">{{ multipleSelection.length }}</span>
            条
          </span>
        </div>
        <div class="toggle-btn" @click="toggleType">
          <span>切换{{ toggleText }}图模式</span>
          <svg-icon icon-class="toggle" />
        </div>
      </div>
      <div class="main-table">
        <el-table
          :data="estates"
          ref="estateTable"
          stripe
          style="width: 100%"
          @selection-change="handleSelectionChange"
          @sort-change="changeSort"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column
            label="楼盘图片"
            v-if="toggleText == '无'"
            width="200"
          >
            <template slot-scope="scope">
              <div class="estate-photo-box">
                <el-image
                  class="estate-photo"
                  :src="scope.row.coverUrl ? scope.row.coverUrl : defaultCover"
                  lazy
                ></el-image>
                <img
                  src="@/assets/image/3D.png"
                  v-if="scope.row.isHasVr"
                  class="estate-video"
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column label="楼盘名称" min-width="210">
            >
            <template slot-scope="scope">
              <div v-if="toggleText == '有'" >
                <span
                  class="estate-name-item"
                  @click="goEstateDetail(scope.row.id)"
                >
                  {{ scope.row.name }}
                </span>

                <span class="estate-type-item" v-if="scope.row.isMainPush"
                  >主推</span
                >
              </div>
              <div v-else class="estate-name-box">
                <div class="estate-name" @click="goEstateDetail(scope.row.id)">
                  {{ scope.row.name }}
                </div>
                <div v-if="scope.row.street">
                  {{ scope.row.district }}-{{ scope.row.street }}
                </div>
                <div v-else>{{ scope.row.district }}</div>
                <div>
                  <span class="estate-type-item">{{
                    scope.row.saleStatus
                  }}</span>
                  <span class="estate-type-item">{{ scope.row.reside }}</span>
                  <span class="estate-type-item" v-if="scope.row.buildType">{{
                    scope.row.buildType
                  }}</span>
                  <span class="estate-type-item" v-if="scope.row.isMainPush"
                    >主推</span
                  >
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="行政区/街道"
            min-width="150"
            v-if="isAreaShow"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.street"
                >{{ scope.row.district }}-{{ scope.row.street }}</span
              >
              <span v-else>{{ scope.row.district }}</span>
            </template>
          </el-table-column>
          <el-table-column label="用途" min-width="150" show-overflow-tooltip>
            <template slot-scope="scope">
              <div v-if="scope.row.usingTypes.length">
                <span v-for="(item, index) in scope.row.usingTypes" :key="index"
                  >{{ item }}
                </span>
              </div>
              <div v-else>—</div>
            </template>
          </el-table-column>
          <el-table-column
            label="总价(万)"
            sortable
            width="130"
            prop="minTotalPrice"
          >
            <template slot-scope="scope">
              <span
                >{{ scope.row.minTotalPrice }} -
                {{ scope.row.maxTotalPrice }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            label="均价(元/㎡)"
            sortable
            width="130"
            prop="minPrice"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.minPrice }} - {{ scope.row.maxPrice }}</span>
            </template>
          </el-table-column>
          <el-table-column label="项目负责人" min-width="150" show-overflow-tooltip>
            <template slot-scope="scope">
              <div v-if="scope.row.counselors.length">
                <span v-for="(item, index) in scope.row.counselors" :key="index"
                  >{{ item.userName }}
                </span>
              </div>
              <div v-else>—</div>
            </template>
          </el-table-column>
          <el-table-column
            label="更新时间"
            sortable
            width="100"
            prop="lastModificationTime"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.lastModificationTime">{{
                scope.row.lastModificationTime | dateFormatYMD
              }}</span>
              <span v-else>{{ scope.row.creationTime | dateFormatYMD }}</span>
            </template>
          </el-table-column>
          <el-table-column label="网站上架/下架" width="110">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.isPutWeb"
                @change="putWebChange(scope.row.id, scope.row.isPutWeb)"
              >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column label="渠道上架/下架" width="110">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.isPutChannel"
                @change="putChannelChange(scope.row.id, scope.row.isPutChannel)"
              >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="170" fixed="right">
            <template slot-scope="scope">
              <div class="table-operation">
                <el-button
                  @click.native.prevent="goEstateDetail(scope.row.id)"
                  type="text"
                  >管理</el-button
                >
                <el-button
                  v-if="scope.row.isMainPush"
                  @click.native.prevent="cancelMain(scope.row.id)"
                  type="text"
                  >取消主推</el-button
                >
                <el-button
                  v-else
                  @click.native.prevent="setMain(scope.row.id)"
                  type="text"
                  >设为主推</el-button
                >
                <el-popover placement="bottom" trigger="click">
                  <el-button
                    @click.native.prevent="delEstate(scope.row.id)"
                    type="text"
                    class="del-btn"
                    >删除</el-button
                  >
                  <el-button slot="reference" type="text" class="more-btn"
                    >更多</el-button
                  >
                </el-popover>
              </div>
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="loading-box" v-if="isLoading">
              <img
                src="@/assets/image/loading.png"
                alt="loading"
                class="loading-ico"
              />
              数据加载中...
            </div>
            <div class="empty-box" v-if="!isLoading && !estates.length">
              列表为空
            </div>
          </template>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageIndex"
          :page-sizes="[20, 50, 100]"
          :page-size="query.maxResultCount"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="设为主推"
      :visible.sync="isSetMain"
      @close="setMainClose"
      class="dialog-top set-main"
    >
      <el-form
        ref="setMainForm"
        :model="setMainForm"
        label-position="left"
        label-width="7rem"
        :rules="setMainRules"
      >
        <el-form-item label="主推优先级" prop="grade">
          <el-select
            v-model="setMainForm.grade"
            clearable
            placeholder="请选择主推优先级"
          >
            <el-option
              v-for="item in gradeOptions"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="主推起止时间" prop="range">
          <el-date-picker
            align="center"
            v-model="setMainForm.range"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isSetMain = false">取 消</el-button>
        <el-button type="primary" @click="submitSetMain">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import headerTop from "@/components/HeaderTop";
import { debounce } from "@/utils/debounce";
import { dateFormat, dateFormatYMD, getEnumOptions } from "@/common/filters";
import {
  getEstates,
  deleteEstate,
  deleteEstates,
  updatePushWeb,
  updatePushChannel,
  updateMainPush,
} from "@/http/api/estate";
import { areaSearchTree } from "@/http/api/area";
import { deepCopy } from "@/utils/deepCopy";
import { estateSettings, getTenantSettings } from "@/http/api/system";

export default {
  components: {
    headerTop,
  },
  data() {
    return {
      permissions: {},
      defaultCover: require("@/assets/image/estate-cover.jpg"),
      type: "",
      searchKey: "",
      searchValue: "",
      search: "全文搜索",
      searchText: "请输入楼盘名称/地址/项目负责人",
      build: "",
      unit: "",
      roomNum: "",
      filterDate: "",
      mainPushId: "",
      toggleText: "有",
      totalCount: 0,
      selectedNum: 0,
      pageIndex: 1,
      isAreaShow: true,
      isLoading: true,
      isSetMain: false,
      notRefresh: false,
      filterInitData: {},
      setMainForm: {
        grade: "",
        range: "",
      },
      setMainRules: {
        grade: [
          { required: true, message: "请选择主推优先级", trigger: "change" },
        ],
        range: [
          { required: true, message: "请选择主推起止时间", trigger: "change" },
        ],
      },
      query: {
        maxResultCount: 20,
        saleStatus: "",
        isPutWeb: "",
        isPutChannel: "",
        isMainPush: "",
        usingType: "",
        creationStartTime: "",
        creationEndTime: "",
        launchStartTime: "",
        launchEndTime: "",
        district: "",
        city: "",
        sorting: "creationTime desc",
      },
      filterTags: [],
      filterData: {
        position: [],
        district: [],
        saleStatus: [],
        isPutWeb: [
          {
            label: "已上架",
            value: true,
            isSelected: false,
          },
          {
            label: "已下架",
            value: false,
            isSelected: false,
          },
        ],
        isPutChannel: [
          {
            label: "已上架",
            value: true,
            isSelected: false,
          },
          {
            label: "已下架",
            value: false,
            isSelected: false,
          },
        ],
        filter: [
          {
            name: "主推状态",
            label: "isMainPush",
            children: [
              { name: "不限", value: "" },
              { name: "主推", value: true },
              { name: "未主推", value: false },
            ],
          },
          {
            name: "用途",
            label: "usingType",
            children: [],
          },
          {
            name: "创建时间",
            label: "creationTime",
            children: [
              { name: "自定义" },
              { name: "不限" },
              { name: "今日" },
              { name: "3日内" },
              { name: "7日内" },
              { name: "15日内" },
            ],
          },
          {
            name: "开盘时间",
            label: "launchTime",
            children: [
              { name: "自定义" },
              { name: "不限" },
              { name: "今日" },
              { name: "3日内" },
              { name: "7日内" },
              { name: "15日内" },
            ],
          },
        ],
      },
      searchOptions: [
        {
          value: "",
          label: "全文搜索",
        },
        {
          value: "name",
          label: "楼盘名称",
        },
        {
          value: "realAddress",
          label: "楼盘地址",
        },
        {
          value: "userName",
          label: "项目负责人",
        },
        
      ],
      gradeOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      estates: [],
      multipleSelection: [],
      areas: [],
    };
  },
  methods: {
    areaSearchAllTree() {
      getTenantSettings().then((res) => {
        let arr = [];
        res.result.map(el=>{
            if (el.name=='Deer.Tenant.Collection.DomainArea') {
                el.value.map(item=>{
                    arr.push({ data: { name: item.option, isSelected: false } });
                })
            }
        })
        // areaSearchAllTree().then((res) => {
        //   let arr = [];
        //   res.result.items.map((item) => {
        //     if (item.data.status) {
        //       arr.push(item);
        //       //console.log(item,963258741);
        //     }
        //   });
        //   //console.log(arr,'arr');
        //   arr.map((el) => {
        //     el.data.isSelected = false;
        //     if (el.children.length) {
        //       el.children.map((item) => {
        //         item.data.isSelected = false;
        //       });
        //     }
        //   });
        arr.unshift({
          data: { name: "不限", isSelected: true },
          children: [],
        });
        this.areas = deepCopy(arr);
        this.filterData.position = arr;
        this.getSettings();
      });
    },
    // 搜索楼盘
    searchEstates() {
      if (this.searchValue) {
        this.getEstates();
      }
    },
    changeSort(val) {
      //console.log(val, 555);
      this.query.sorting =
        val.order == "descending"
          ? `${val.prop} desc`
          : val.order == "ascending"
          ? `${val.prop} asc`
          : "";
      this.getEstates();
    },
    // 更新渠道上架状态
    putChannelChange(id, v) {
      updatePushChannel(id, v).then((res) => {
        let msg = v ? "上架成功" : "下架成功";
        if (res) {
          this.$message.success({ message: msg, showClose: true });
        }
        this.notRefresh = true;
        this.getEstates();
      });
    },
    // 更新网站上架状态
    putWebChange(id, v) {
      updatePushWeb(id, v).then((res) => {
        //console.log(res, "res");
        let msg = v ? "上架成功" : "下架成功";
        if (res) {
          this.$message.success({ message: msg, showClose: true });
        }
        this.notRefresh = true;
        this.getEstates();
      });
    },
    // 批量删除楼盘
    delEstates() {
      if (this.permissions["Estate.Delete"]) {
        this.$confirm(`删除后楼盘将不存在，请谨慎操作！`, "温馨提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        })
          .then(() => {
            let arr = [];
            this.multipleSelection.map((el) => {
              arr.push("ids=" + el);
            });
            arr = arr.join("&");
            deleteEstates(arr).then((res) => {
              this.notRefresh = true;
              this.getEstates();
              if (res) {
                this.$message.success({ message: "删除成功", showClose: true });
              }
            });
          })
          .catch(() => {
            //console.log("已取消");
          });
      } else {
        this.$message.warning({
          message: "您暂无删除楼盘权限",
          showClose: true,
        });
      }
    },
    // 取消主推
    cancelMain(v) {
      if (this.permissions["Estate.Update"]) {
        this.$confirm(
          `确定将此楼盘取消主推？将楼盘取消主推将不排在列表最前面`,
          "取消主推",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
          }
        )
          .then(() => {
            let data = {
              isMainPush: false,
            };
            updateMainPush(v, data).then((res) => {
              this.isSetMain = false;
              if (res) {
                this.$message.success({ message: "取消成功", showClose: true });
              }
              this.notRefresh = true;
              this.getEstates();
            });
          })
          .catch(() => {
            //console.log("已取消");
          });
      } else {
        this.$message.warning({
          message: "您暂无管理楼盘权限",
          showClose: true,
        });
      }
    },
    // 主推弹窗关闭回调
    setMainClose() {
      this.$refs["setMainForm"].resetFields();
    },
    // 设置主推确认回调
    submitSetMain() {
      this.$refs["setMainForm"].validate((valid) => {
        if (valid) {
          let data = {
            isMainPush: true,
            startTime: dateFormat(this.setMainForm.range[0]),
            endTime: dateFormat(this.setMainForm.range[1]),
            sort: this.setMainForm.grade,
          };
          updateMainPush(this.mainPushId, data).then((res) => {
            this.isSetMain = false;
            if (res) {
              this.$message.success({ message: "设置成功", showClose: true });
            }
            this.notRefresh = true;
            this.getEstates();
          });
        } else {
          //console.log("表单验证未通过");
          return false;
        }
      });
    },
    // 设为主推
    setMain(v) {
      if (this.permissions["Estate.Update"]) {
        this.mainPushId = v;
        this.isSetMain = true;
      } else {
        this.$message.warning({
          message: "您暂无管理楼盘权限",
          showClose: true,
        });
      }
    },
    //删除楼盘
    delEstate(id) {
      if (this.permissions["Estate.Delete"]) {
        this.$confirm(
          `确定删除此楼盘？删除后楼盘将不存在，请谨操作！`,
          "温馨提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
          }
        )
          .then(() => {
            deleteEstate(id).then((res) => {
              this.notRefresh = true;
              this.getEstates();
              if (res) {
                this.$message.success({ message: "删除成功", showClose: true });
              }
            });
          })
          .catch(() => {
            //console.log("已取消");
          });
      } else {
        this.$message.warning({
          message: "您暂无删除楼盘权限",
          showClose: true,
        });
      }
    },
    init() {
      this.permissions = this.$store.getters.permissions;
      this.$watch(
        "searchValue",
        debounce((val) => {
          this.getEstates();
        }, 200)
      );
      this.filterData.saleStatus.unshift({
        label: "不限",
        value: "",
        isSelected: true,
      });
      let saleStatus = this.$store.getters.enumMetadata.EstateSaleStatus;
      for (var key in saleStatus) {
        this.filterData.saleStatus.push({
          label: saleStatus[key],
          value: key,
          isSelected: false,
        });
      }
      this.getEstates();
      this.areaSearchAllTree();
    },
    // 获取基础字段
    getSettings() {
      estateSettings().then((res) => {
        this.filterData.filter.map((el) => {
          if (el.label == "usingType") {
            el.children = getEnumOptions(
              res.result,
              "Deer.Estate.Collection.UsingType"
            );
            el.children.unshift({
              name: "不限",
              value: "",
            });
          }
        });
        this.filterInitData = deepCopy(this.filterData);
      });
    },
    // 获取楼盘
    getEstates() {
      let query = {
        sorting: this.query.sorting,
        maxResultCount: this.query.maxResultCount,
        skipCount: (this.pageIndex - 1) * this.query.maxResultCount,
      };
      if (this.searchValue) {
        query.filter = this.searchValue;
        if (this.searchKey) {
          query.condition = this.searchKey;
        }
      }
      if (this.query.saleStatus) {
        query.saleStatus = this.query.saleStatus;
      }
      if (this.query.city && this.query.city != "不限") {
        query.city = this.query.city;
      }
      if (!this.query.city || this.query.city == "不限") {
        query.city = "";
        this.query.district = "";
        query.district = "";
      }
      //console.log();
      if (this.query.district && this.query.district != "不限") {
        query.district = this.query.district;
      } else {
        query.district = "";
      }
      if (this.query.isPutWeb !== "") {
        query.isPutWeb = this.query.isPutWeb;
      }
      if (this.query.isPutChannel !== "") {
        query.isPutChannel = this.query.isPutChannel;
      }
      if (this.query.isMainPush !== "") {
        query.isMainPush = this.query.isMainPush;
      }
      if (this.query.usingType) {
        query.usingType = this.query.usingType;
      }
      if (this.query.creationStartTime) {
        query.creationStartTime = dateFormat(this.query.creationStartTime);
        query.creationEndTime = dateFormat(this.query.creationEndTime);
      }
      if (this.query.launchStartTime) {
        query.launchStartTime = dateFormat(this.query.launchStartTime);
        query.launchEndTime = dateFormat(this.query.launchEndTime);
      }
      if (this.query.sorting) {
        query.sorting = this.query.sorting;
      }
      this.isLoading = true;
      if (!this.notRefresh) {
        this.estates = [];
      }
      this.notRefresh = false;
      getEstates(query).then((res) => {
        //console.log(res, "estates");
        if (res && res.result) {
          this.estates = res.result.items;
          this.totalCount = res.result.totalCount;
        }
        this.isLoading = false;
      });
    },
    // 搜索前置条件
    filterSelect(val) {
      switch (val) {
        case "name":
          this.searchText = "请输入楼盘名称";
          break;
        case "realAddress":
          this.searchText = "请输入楼盘地址";
          break;
        case "userName":
          this.searchText = "请输入项目负责人";
          break;
        case "":
          this.searchText = "请输入楼盘名称/地址/项目负责人";
          break;
      }
      this.searchKey = val;
    },
    // 新建楼盘
    createEstate() {
      if (this.permissions["Estate.Create"]) {
        this.$router.push({ name: "estateCreate" });
      } else {
        this.$message.warning({
          message: "您暂无添加新楼盘权限",
          showClose: true,
        });
      }
    },
    // 筛选项时间自定义回调
    changeFilterDate(v, name) {
      let value = dateFormatYMD(v[0]) + "~" + dateFormatYMD(v[1]);
      this.filterTagsPush(name, value, v);
    },
    // 选择搜索项
    selectItem(arr, label, value, name, key) {
      if (name == "位置") {
        //console.log(arr, label, value, name, key, "获取的地区信息");
        arr.map((el) => {
          if (el.data.name == label) {
            el.data.isSelected = true;
          } else {
            el.data.isSelected = false;
          }
        });
        this.filterData.district = [];
        if (value!='不限') {
          areaSearchTree({ ParentName: value }).then((res) => {
            if (res.result.items.length == 0) {
              this.filterData.district = [];
            } else {
              this.filterData.district = res.result.items;
              if (this.filterData.district.length > 0) {
                this.filterData.district.unshift({
                  data: { name: "不限", isSelected: true },
                  children: [],
                });
              }
            }
          });
        }
      } else if (name == "区县") {
        arr.map((el) => {
          if (el.data.name == label) {
            el.data.isSelected = true;
          } else {
            el.data.isSelected = false;
          }
        });
      } else {
        arr.map((el) => {
          if (el.label == label) {
            el.isSelected = true;
          } else {
            el.isSelected = false;
          }
        });
      }
      this.filterTagsPush(name, label, value, key);
    },
    // 清空搜索条件
    clearTags() {
      this.filterTags = [];
      this.filterData = deepCopy(this.filterInitData);
      Object.assign(this.$data.query, this.$options.data().query);
      this.$nextTick(() => {
        this.filterData.position = this.areas;
        this.filterData.district = [];
      });
      this.searchKey = "";
      this.searchText = "请输入楼盘名称/地址/项目负责人";
      this.search = "前缀搜索";
      this.searchValue = "";
      this.getEstates();
    },
    // 筛选条件添加
    filterTagsPush(name, label, value, key) {
      //console.log(name, label, value, key, "huoqutag");
      if (label != "自定义") {
        let obj = { name, label };
        let item = this.filterTags.find((el) => {
          return el.name == name;
        });
        if (item) {
          this.filterTags.map((el) => {
            if (el.name == name) {
              if (label) {
                if (label == "不限") {
                  this.filterTags.splice(this.filterTags.indexOf(el), 1);
                } else {
                  el.label = label;
                }
              } else {
                this.filterTags.splice(this.filterTags.indexOf(el), 1);
              }
            }
          });
        } else {
          if (label && label != "不限") {
            this.filterTags.push(obj);
          }
        }
      }
      if (name == "区县") {
        if (label != "不限") {
          let tagIndex = 0;
          this.filterTags.map((item, index) => {
            if (item.name == "位置") {
              if (item.label.indexOf("-") != -1) {
                item.label = item.label.split("-")[0] + "-" + label;
              } else {
                item.label = item.label + "-" + label;
              }
              // item.label = item.label + "-" + label;
            }
            if (item.name == "区县") {
              tagIndex = index;
            }
          });
          this.filterTags.splice(tagIndex, 1);
        } else {
          this.filterTags.map((item, index) => {
            if (item.name == "位置") {
              item.label = item.label.split("-")[0];
            }
          });
        }
      }
      if (name == "创建时间") {
        //console.log(name, label, value, key, "name, label, value, key");
        if (label == "今日") {
          this.query.creationStartTime = new Date(
            new Date(new Date().toLocaleDateString()).getTime()
          );
          this.query.creationEndTime = new Date();
          //console.log(this.query, "this.query");
        } else if (label == "3日内") {
          this.query.creationStartTime = new Date(
            new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 * 3
          );
          this.query.creationEndTime = new Date();
        } else if (label == "7日内") {
          this.query.creationStartTime = new Date(
            new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 * 7
          );
          this.query.creationEndTime = new Date();
        } else if (label == "15日内") {
          this.query.creationStartTime = new Date(
            new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 * 15
          );
          this.query.creationEndTime = new Date();
        } else if (label == "不限") {
          this.query.creationStartTime = "";
          this.query.creationEndTime = "";
        } else {
          this.query.creationStartTime = value[0];
          this.query.creationEndTime = value[1];
        }
      } else if (name == "开盘时间") {
        if (label == "今日") {
          this.query.launchStartTime = new Date(
            new Date(new Date().toLocaleDateString()).getTime()
          );
          this.query.launchEndTime = new Date();
        } else if (label == "3日内") {
          this.query.launchStartTime = new Date(
            new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 * 3
          );
          this.query.launchEndTime = new Date();
        } else if (label == "7日内") {
          this.query.launchStartTime = new Date(
            new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 * 7
          );
          this.query.launchEndTime = new Date();
        } else if (label == "15日内") {
          this.query.launchStartTime = new Date(
            new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 * 15
          );
          this.query.launchEndTime = new Date();
        } else if (label == "不限") {
          this.query.launchStartTime = "";
          this.query.launchEndTime = "";
        } else {
          this.query.launchStartTime = value[0];
          this.query.launchEndTime = value[1];
        }
      } else if (name == "位置") {
        this.query.city = label;
      } else if (name == "区县") {
        this.query.district = label;
      } else {
        this.query[key] = value;
      }

      this.getEstates();
    },
    // 移除筛选标签
    handleTagClose(tag) {
      this.filterTags.splice(this.filterTags.indexOf(tag), 1);
      switch (tag.name) {
        case "位置":
          this.query.city = "";
          this.query.district = "";
          this.$nextTick(() => {
            this.filterData.position = this.areas;
            this.filterData.district = [];
          });
          break;
        case "销售状态":
          this.filterDateInit("saleStatus");
          this.query.saleStatus = "";
          break;
        case "网站上架":
          this.filterDateInit("isPutWeb");
          this.query.isPutWeb = "";
          break;
        case "渠道上架":
          this.filterDateInit("isPutChannel");
          this.query.isPutChannel = "";
          break;
        case "主推状态":
          this.query.isMainPush = "";
          break;
        case "用途":
          this.query.usingType = "";
          break;
        case "创建时间":
          this.query.creationStartTime = "";
          this.query.creationEndTime = "";
          break;
        case "开盘时间":
          this.query.launchStartTime = "";
          this.query.launchEndTime = "";
          break;
      }
      this.getEstates();
    },
    // 筛选项isSelected初始化
    filterDateInit(v) {
      this.filterData[v].map((el) => {
        if (el.label == "不限") {
          el.isSelected = true;
        } else {
          el.isSelected = false;
        }
      });
    },
    // 跳转楼盘详情
    goEstateDetail(id) {
      this.$router.push("/estate/detail/" + id);
    },
    // 多选框回调
    handleSelectionChange(val) {
      this.multipleSelection = [];
      val.map((el) => {
        this.multipleSelection.push(el.id);
      });
    },
    // 更改的页面数量
    handleSizeChange(val) {
      this.query.maxResultCount = val;
      this.getEstates();
    },
    // 跳转的指定页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getEstates();
    },
    // 切换表格模式
    toggleType() {
      this.toggleText = this.toggleText == "有" ? "无" : "有";
      this.$nextTick(() => {
        this.isAreaShow = !this.isAreaShow;
        //在数据加载完，重新渲染表格,防止抖动
        this.$nextTick(() => {
          this.$refs["estateTable"].doLayout();
        });
      });
    },
    // 筛选项下拉菜单的子菜单回调
    dropdownChildClick(v) {
      let name = v.split(" ")[0];
      let value = v.split(" ")[1];
      this.filterTagsPush(name, value);
      this.$refs[name][0].hide();
    },
    // 筛选项下拉菜单回调
    dropdownClick(command) {
      let name = command.split(" ")[0];
      let label = command.split(" ")[1];
      let value = command.split(" ")[2];
      let key = command.split(" ")[3];
      if (label != "自定义") {
        this.filterTagsPush(name, label, value, key);
      }
    },
    // tab页动态切换初始化
    activeInit(v) {
      this.activeName = v;
    },
    // 筛选项下拉菜单中的选择框点击回调
    changeCorrelation() {
      this.$refs.correlationDropdown.show();
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.estate {
  .estate-main {
    margin: 20px;
    border-radius: $--border-radius-base;
    padding: 20px;
    background-color: #fff;

    .main-top {
      display: flex;

      .input-with-select {
        width: 410px;
        .el-select {
          width: 115px;
        }
      }
    }

    .main-filter {
      margin: 20px 0;
      border-radius: $--border-radius-base;
      padding: 10px;
      background: #f9f9fa;

      .filter-item {
        display: flex;
        height: 24px;
        align-items: center;
        margin-bottom: 10px;

        .el-dropdown {
          cursor: pointer;
        }

        .filter-lable {
          margin-right: 24px;
          white-space: nowrap;
          cursor: pointer;
          transition: all 0.1s;
        }

        .is-selected {
          color: $--color-primary;
        }

        ::v-deep .el-input {
          width: 70px;
          height: 24px;

          .el-input__inner {
            height: 24px;
            line-height: 24px;

            &::placeholder {
              font-size: 12px;
            }

            &::-webkit-input-placeholder {
              /* WebKit browsers 适配谷歌 */
              font-size: 12px;
            }

            &:-moz-placeholder {
              /* Mozilla Firefox 4 to 18 适配火狐 */
              font-size: 12px;
            }

            &::-moz-placeholder {
              /* Mozilla Firefox 19+ 适配火狐 */
              font-size: 12px;
            }

            &:-ms-input-placeholder {
              /* Internet Explorer 10+  适配ie*/
              font-size: 12px;
            }
          }
        }

        .input-line {
          margin: 0 5px;
        }

        .input-unit {
          margin-left: 8px;
        }

        .el-dropdown {
          margin-right: 24px;
          margin-bottom: 10px;
        }

        .el-button--mini {
          margin-left: 5px;
        }
      }
      .filter-children-item {
        padding-left: 84px;
      }
      .filter-filter {
        margin-bottom: -8px;
        height: auto;
        align-items: flex-start;
      }
    }

    .main-condition {
      display: flex;
      border-bottom: 1px solid #ddd;
      margin-top: -6px;
      margin-bottom: 10px;
      padding-bottom: 10px;
      .condition-text {
        line-height: 28px;
        margin-right: 15px;
        height: 28px;
        white-space: nowrap;
      }

      .tag-items {
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        ::v-deep .el-tag {
          margin-right: 10px;
          margin-bottom: 5px;
          color: #666;

          .el-icon-close {
            transform: scale(1);
          }
        }

        .clear-btn {
          height: 28px;
          cursor: pointer;
          margin-left: 10px;

          &:hover {
            color: #000;
          }
          i {
            margin-right: 5px;
          }
        }
      }
    }

    .main-btns {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;

      .table-top {
        color: #999;
        margin-left: 10px;

        .selected-num {
          color: $--color-primary;
        }
      }

      .toggle-btn {
        display: flex;
        align-items: center;
        cursor: pointer;
        color: #333;

        .svg-icon {
          margin-left: 5px;
          height: 19px;
        }
      }
    }

    .main-table {
      ::v-deep .el-table {
        margin-bottom: 20px;

        .estate-name-box {
          height: 100px;
          display: flex;
          justify-content: space-around;
          flex-direction: column;
        }
        .estate-name {
          cursor: pointer;
          font-weight: bolder;
          &:hover {
            color: $--color-primary;
          }
        }

        .estate-name-item {
          cursor: pointer;
          &:hover {
            color: $--color-primary;
          }
        }

        .estate-type-item {
          background-color: $--color-primary;
          border-radius: 2px;
          color: #fff;
          display: inline-block;
          font-size: 12px;
          line-height: 18px;
          margin-left: 4px;
          padding: 0 4px;
          text-align: center;
        }
        
        .estate-name-box{
          .estate-type-item{
            margin-left: 0;
            margin-right: 4px;
          }
        }
        .tag-item {
          background-color: #f2f2f2;
          color: $--color-primary;
        }

        .icon-item {
          color: #688ebf;
        }

        .picture-icon {
          .svg-icon {
            margin-top: -1px;
          }
        }

        .estate-photo-box {
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          width: 160px;
          height: 120px;

          .estate-photo {
            width: 100%;
            height: 100%;
          }

          .estate-video {
            position: absolute;
            width: 30px;
            height: 30px;
          }
        }
      }
    }
  }

  .set-main {
    .el-select {
      width: 250px;
    }
  }
}

.correlation-dropdown {
  padding: 10px;

  .correlation-btns {
    margin-top: 10px;
    text-align: right;
  }
}
</style>